<template>
  <b-modal hide-header centered size="lg" hide-footer id="modal-image" @hide="closeModal">
    <div class="modal-container" v-if="src">
      <img v-img-fb="src" alt="" />
    </div>
  </b-modal>
</template>

<style scoped>
.modal-container {
  width: 100%;
  max-height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-container img {
  width: auto;
  height: 100%;
}
</style>

<script>
export default {
  name: "image-modal",
  props: {
    src: {
      required: false,
      default: () => null,
    },
  },

  methods: {
    openModal() {
      this.$bvModal.show("modal-image");
    },

    closeModal() {
      this.$emit("close");
      this.$bvModal.hide("modal-image");
    },
  },

  watch: {
    src: {
      immediate: false,
      deep: false,
      handler(t, f) {
        if (t) {
          this.openModal();
        } else {
          this.closeModal();
        }
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/base/component/image-modal.vue